import { createContext } from 'react';
import { PushNotificationEvent } from 'services/types/pushNotifications';

interface NotificationsContextType {
  registerHandler: (handler: (event: PushNotificationEvent) => void) => () => void;
}

export const NotificationsContext = createContext<NotificationsContextType>(null!);
